export const ANIMATION_DURATION = 500
export const CHART_HEIGHT = 280
